import React , { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';


import { connect , useDispatch} from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../actions/index';

import AlumniPrivacyOptionsModal from '../Dashboard/privacyOptionsModal';


const PrivateAlumniRoute = (props) => {
  const { component: Component, ...rest } = props;
    const needToRedirectToPrivacySettings = JSON.parse(localStorage.getItem('privacy-setting'));
    useEffect(() => {
      // props.actions.isadmin()
    }, [])

    
    return( 
        <Route {...rest} render={props => (
                    localStorage.getItem('user') ?
                     needToRedirectToPrivacySettings && window.location.pathname !== '/privacy-setting' ? <Redirect to={{ pathname: '/privacy-setting'}} />
                    : 
                    <Component {...props} />
                    : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
            )} />
)}


const mapStateToProps = (state) => ({
    isadminLoading: state.isadminreducer.loading,
    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators(actions, dispatch)
    }
  }
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateAlumniRoute));


// WEBPACK FOOTER //
// ./src/components/HOC/PrivateAlumniRoute.js